var q = Object.defineProperty;
var J = (A, e, t) => e in A ? q(A, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : A[e] = t;
var d = (A, e, t) => J(A, typeof e != "symbol" ? e + "" : e, t);
import { C as v, a as b, M as L, v as k } from "../js/vendor.B946LCjM.js";
import C from "axios";
import { M as h } from "../js/components.lyCg6H7r.js";
import "vue";
import * as F from "utif2";
class At {
  /* 
   * Collapse要素の展開
   */
  static showCollapseById(e) {
    var t = document.getElementById(e);
    if (t) {
      var n = new v(t, { toggle: !1 });
      n.show();
    }
  }
  /* 
   * Collapse要素の折りたたみ(ID指定)
   */
  static hideCollapseById(e) {
    var t = document.getElementById(e);
    if (t) {
      var n = new v(t, { toggle: !1 });
      n.hide();
    }
  }
  /* 
   * Collapse要素の折りたたみ(className指定)
   */
  static hideCollapseByClassName(e) {
    var t = document.getElementsByClassName(e);
    Array.from(t).forEach((n) => {
      var r = new v(n, { toggle: !1 });
      r.hide();
    });
  }
  /* 
   * Collapse要素の折りたたみ(querySelector指定)
   */
  static hideCollapseByQuerySelector(e) {
    var t = document.querySelectorAll(e);
    t.forEach((n) => {
      var r = new v(n, { toggle: !1 });
      r.hide();
    });
  }
  /* 
   * Collapse要素の展開/折りたたみ
   */
  static toggleCollapseById(e) {
    var t = document.getElementById(e);
    if (t) {
      var n = new v(t);
      n.toggle();
    }
  }
  /* 
   * Tab要素の展開(ID指定)
   */
  static showTabById(e) {
    var t = document.getElementById(e);
    if (t) {
      var n = new b(t);
      n.show();
    }
  }
  /* 
   * Tab要素の展開(querySelector指定)
   */
  static showTabByQuerySelector(e) {
    var t = document.querySelectorAll(e);
    t.forEach((n) => {
      var r = new b(n);
      r.show();
    });
  }
  /* 
   * Modal要素の表示
   */
  static showModal(e, t) {
    var n = document.getElementById(e);
    if (n) {
      var r = new L(n, t);
      r.show();
    }
  }
  /* 
   * Modal要素を閉じる
   */
  static hideModal(e) {
    var t = document.getElementById(e);
    if (t) {
      var n = L.getInstance(t);
      n && n.hide();
    }
  }
}
const y = {
  /** 切り上げ */
  RoundUp: "RoundUp",
  /** 四捨五入 */
  Round: "Round",
  /** 切り捨て */
  RoundDown: "RoundDown"
}, M = class M {
  // -----------------------------------------------------------
  // GB/MB/KB/Bytes自動変換（少数第2位まで表示）
  // -----------------------------------------------------------
  static ConvStorage(e) {
    let t = "";
    return e >= this.DEF_COMV_STOREGE_GB ? t = this.ConvStorageGB(e) : e >= this.DEF_COMV_STOREGE_MB ? t = this.ConvStorageMB(e) : e >= this.DEF_COMV_STOREGE_KB ? t = this.ConvStorageKB(e) : t = String(e) + "Bytes", t;
  }
  // -----------------------------------------------------------
  // 指定サイズをGB単位で変換する。（少数第3位まで表示）
  // -----------------------------------------------------------
  static ConvStorageGB(e) {
    let t;
    t = e / (this.DEF_COMV_STOREGE_GB * 1), t *= 1e3;
    const n = Math.floor(t / 1e3), r = Math.floor(t % 1e3);
    return String(n) + "." + String(Math.floor(r * 1e4) / 1e4) + "GB";
  }
  // -----------------------------------------------------------
  // 指定サイズをMB単位で変換する。（少数第2位まで表示）
  // -----------------------------------------------------------
  static ConvStorageMB(e) {
    let t;
    t = e / (this.DEF_COMV_STOREGE_MB * 1), t *= 100;
    const n = Math.floor(t / 100), r = Math.floor(t % 100);
    return String(n) + "." + String(Math.floor(r * 1e3) / 1e3) + "MB";
  }
  // -----------------------------------------------------------
  // 指定サイズをKB単位で変換する。（少数第2位まで表示）
  // -----------------------------------------------------------
  static ConvStorageKB(e) {
    let t;
    t = e / (this.DEF_COMV_STOREGE_KB * 1), t *= 100;
    const n = Math.floor(t / 100), r = Math.floor(t % 100);
    return String(n) + "." + String(Math.floor(r * 1e3) / 1e3) + "KB";
  }
  /**
   * 指定サイズをKB単位で変換する。
   * @param llSize サイズ
   * @param decimalPlaces 少数第何位
   * @param roundType ラウンドタイプ
   */
  static CustomConvStorageKB(e, t = 2, n = y.RoundDown) {
    let r = e / (this.DEF_COMV_STOREGE_KB * 1);
    return r = M.roundValue(r, t, n), r.toFixed(t).toString() + "KB";
  }
  /**
   * 指定された小数点以下の桁数で数値を丸める関数
   * @param value 値
   * @param decimalPlaces 少数第何位まで残すか
   * @param roundType 丸め方法
   * @returns 丸めた後の値
   */
  static roundValue(e, t, n) {
    if (t < 0)
      return e;
    const r = Math.pow(10, t);
    switch (n) {
      case y.Round:
        return Math.round(e * r) / r;
      case y.RoundUp:
        return Math.ceil(e * r) / r;
      case y.RoundDown:
        return Math.floor(e * r) / r;
      default:
        return e;
    }
  }
};
d(M, "DEF_COMV_STOREGE_GB", 1024 * 1024 * 1024), d(M, "DEF_COMV_STOREGE_MB", 1024 * 1024), d(M, "DEF_COMV_STOREGE_KB", 1024);
let P = M;
class st {
  /**
  * クッキー情報からCSRF用のtokenを取得します。
  * @returns 値（なければnull)
  **/
  static getCSRFToken() {
    return this.getCookieData("XSRF-TOKEN");
  }
  /**
   * クッキー情報から引数のキー情報を取得します
   * @param tokenName cookieのキー
   * @returns 値（なければnull)
   */
  static getCookieData(e) {
    var r;
    const n = `; ${document.cookie}`.split(`; ${e}=`);
    return n.length === 2 && ((r = n.pop()) == null ? void 0 : r.split(";").shift()) || null;
  }
}
let p = !1, G = !1;
const D = class D {
  /**
    * @brief	POSTリクエスト
    * @note   ログインセッションが切れている場合はメッセージを表示します。
    * @param  [in]    url         URL
    * @param  [in]    data        送信データ
    * @return	結果
    */
  static async post(e, t) {
    if (p)
      return { status: 401 };
    let n = null;
    try {
      n = await C.post(
        e,
        t,
        {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          },
          cancelToken: this.token()
        }
      );
    } catch (r) {
      if (C.isCancel(r))
        return { status: 499 };
      try {
        n = r.response, n.status === 401 && (p || (p = !0, G ? h.MessageBox("ログインセッションが切れました。再度ログインしてください。<br />※[OK]ボタンを押すと、ログイン画面が表示されます。", D.reload, null, h.MB_ICON_INFO) : h.MessageBox("ログインセッションが切れました。再度ログインしてください。<br />※ページを更新すると、ログイン画面が表示されます。", null, null, h.MB_ICON_INFO)));
      } catch {
        return { status: 500 };
      }
    }
    return n;
  }
  /**
    * @brief	GETリクエスト
    * @note   ログインセッションが切れている場合はメッセージを表示します。
    * @param  [in]    url         URL
    * @return	結果
    */
  static async get(e) {
    if (p)
      return { status: 401 };
    let t = null;
    try {
      t = await C.get(
        e,
        {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          },
          cancelToken: this.token()
        }
      );
    } catch (n) {
      if (C.isCancel(n))
        return { status: 499 };
      try {
        t = n.response, t.status === 401 && (p || (p = !0, G ? h.MessageBox("ログインセッションが切れました。再度ログインしてください。<br />※[OK]ボタンを押すと、ログイン画面が表示されます。", D.reload, null, h.MB_ICON_INFO) : h.MessageBox("ログインセッションが切れました。再度ログインしてください。<br />※ページを更新すると、ログイン画面が表示されます。", null, null, h.MB_ICON_INFO)));
      } catch {
        return { status: 500 };
      }
    }
    return t;
  }
  /**
    * @brief	POSTリクエスト(ダウンロード版)
    * @note   ログインセッションが切れている場合はメッセージを表示します。
    * @param  [in]    url         URL
    * @param  [in]    data        送信データ
    * @return	結果
    */
  static async post_blob(e, t) {
    if (p)
      return { status: 401 };
    let n = null;
    try {
      n = await C.post(
        e,
        t,
        {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          },
          cancelToken: this.token(),
          // blobを指定して受け取れるようにする
          responseType: "blob"
        }
      );
    } catch (r) {
      if (C.isCancel(r))
        return { status: 499 };
      try {
        n = r.response, n.status === 401 && (p || (p = !0, G ? h.MessageBox("ログインセッションが切れました。再度ログインしてください。<br />※[OK]ボタンを押すと、ログイン画面が表示されます。", D.reload, null, h.MB_ICON_INFO) : h.MessageBox("ログインセッションが切れました。再度ログインしてください。<br />※ページを更新すると、ログイン画面が表示されます。", null, null, h.MB_ICON_INFO)));
        try {
          if (n.data != null && n.data != null) {
            let a = await n.data.text();
            a != null && a != "" && (n.data = JSON.parse(a));
          }
        } catch {
        }
      } catch {
        return { status: 500 };
      }
    }
    return n;
  }
  /**
   * @brief   リクエストのキャンセル
   */
  static cancel() {
    this.cancelTokenSource.cancel(), this.cancelTokenSource = C.CancelToken.source();
  }
  /**
   * @brief   キャンセルトークンの取得
   */
  static token() {
    return this.cancelTokenSource.token;
  }
  /**
    * @brief	セッションタイムアウト中かどうか
    * @return	true:セッションタイムアウト中 false:それ以外
    */
  static isSessionTimeout() {
    return p;
  }
  /// <summary>
  /// セッションタイムアウト時にページの更新を行うかどうかをセットする
  /// </summary>
  static SetLogoutOnSessionTimeout(e) {
    G = e;
  }
  /// <summary>
  /// ページリロード
  /// </summary>
  static reload() {
    location.reload();
  }
};
/**
 * @brief	キャンセルトークンソース
 */
d(D, "cancelTokenSource", C.CancelToken.source());
let W = D;
const c = class c {
  /*
   * ローディング開始
   */
  static Start() {
    c.loadingRef != null && (c.loadingcount++, c.loadingRef.startLoading());
  }
  /**
   * 開始されていなければローディング表示を開始します。
   * @return すでにローディング表示されていればfalse、表示されていなければtrueを返します。
   */
  static StartIfNeeded() {
    return c.loadingcount === 0 ? (c.Start(), !0) : !1;
  }
  /*
   * ローディング終了
   */
  static Stop() {
    c.loadingRef != null && c.loadingcount !== 0 && (c.loadingcount--, !(0 < c.loadingcount) && c.loadingRef.stopLoading());
  }
  /**
   * ローディングを強制的に終了します。
   */
  static ForceStop() {
    c.loadingRef != null && (c.loadingcount = 0, c.loadingRef.stopLoading());
  }
  /* 
   * ローディング画面の参照を登録
   * ★App.vue意外から呼び出さないこと★
   */
  static SetLoading(e) {
    c.loadingRef = e;
  }
};
// 参照カウンタ
d(c, "loadingcount", 0), /*
 * ローディング画面のrefs
 */
d(c, "loadingRef");
let V = c;
class it {
  /**
   * モーダル画面を表示します。awaitを組み合わせることでモーダル画面が閉じるまで待つことができます。
   * @param target モーダル画面を表示する要素またはそのID属性
   * @param options モーダル画面のオプション
   * @returns 非同期で結果を受け取るためのPromiseインスタンスを返します。
   *          awaitを併用することでモーダル画面を閉じるまで待つことができます。
   */
  static async doModal(e, t) {
    return new Promise((n) => {
      function r(s) {
        s.target && s.target.removeEventListener(L.Events.hidden, r), n();
      }
      let a = null;
      e instanceof HTMLElement ? a = e : typeof e == "string" && (a = document.getElementById(e)), a && (a.addEventListener(L.Events.hidden, r), new L(a, t).show());
    });
  }
}
class Q {
  /**
   * obj1とobj2が一致するかどうかテストします。
   * @param obj1 比較元
   * @param obj2 比較対象
   * @returns obj1とobj2が一致する場合はtrue、異なる場合はfalseを返します。
   */
  static equals(e, t) {
    const n = Q.getDiff(e, t);
    return 0 < Object.keys(n).length;
  }
  /**
   * obj1とobj2に指定されたJSONオブジェクトの差分を抽出します。
   * @param obj1 比較元
   * @param obj2 比較対象
   * @returns 差分がある箇所のobj2の値を返します。
   */
  static getDiff(e, t) {
    const n = {};
    for (const r in e)
      if (e.hasOwnProperty(r))
        if (!t.hasOwnProperty(r))
          n[r] = void 0;
        else if (typeof e[r] == "object" && typeof t[r] == "object") {
          const a = Q.getDiff(e[r], t[r]);
          0 < Object.keys(a).length && (n[r] = a);
        } else e[r] !== t[r] && (n[r] = t[r]);
    for (const r in t)
      t.hasOwnProperty(r) && !e.hasOwnProperty(r) && (n[r] = t[r]);
    return n;
  }
  /**
   * NULL または undefined か判定します
   * @param obj オブジェクト
   * @returns true: NULL または undefined false:それ以外
   */
  static isNullOrUndefined(e) {
    return e == null;
  }
}
class ot {
  /* 
   * 新しいUUID生成
   */
  static NewID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
      var t = Math.random() * 16 | 0, n = e === "x" ? t : t & 3 | 8;
      return n.toString(16);
    });
  }
}
const Y = [
  "ア",
  "イ",
  "ウ",
  "エ",
  "オ",
  "カ",
  "キ",
  "ク",
  "ケ",
  "コ",
  "サ",
  "シ",
  "ス",
  "セ",
  "ソ",
  "タ",
  "チ",
  "ツ",
  "テ",
  "ト",
  "ナ",
  "ニ",
  "ヌ",
  "ネ",
  "ノ",
  "ハ",
  "ヒ",
  "フ",
  "ヘ",
  "ホ",
  "マ",
  "ミ",
  "ム",
  "メ",
  "モ",
  "ヤ",
  "ヰ",
  "ユ",
  "ヱ",
  "ヨ",
  "ラ",
  "リ",
  "ル",
  "レ",
  "ロ",
  "ワ",
  "ヲ",
  "ン",
  "ガ",
  "ギ",
  "グ",
  "ゲ",
  "ゴ",
  "ザ",
  "ジ",
  "ズ",
  "ゼ",
  "ゾ",
  "ダ",
  "ヂ",
  "ヅ",
  "デ",
  "ド",
  "バ",
  "ビ",
  "ブ",
  "ベ",
  "ボ",
  "パ",
  "ピ",
  "プ",
  "ペ",
  "ポ",
  "ァ",
  "ィ",
  "ゥ",
  "ェ",
  "ォ",
  "ャ",
  "ュ",
  "ョ",
  "ッ",
  "゛",
  "°",
  "、",
  "。",
  "「",
  "」",
  "ー",
  "・"
], z = [
  "ｱ",
  "ｲ",
  "ｳ",
  "ｴ",
  "ｵ",
  "ｶ",
  "ｷ",
  "ｸ",
  "ｹ",
  "ｺ",
  "ｻ",
  "ｼ",
  "ｽ",
  "ｾ",
  "ｿ",
  "ﾀ",
  "ﾁ",
  "ﾂ",
  "ﾃ",
  "ﾄ",
  "ﾅ",
  "ﾆ",
  "ﾇ",
  "ﾈ",
  "ﾉ",
  "ﾊ",
  "ﾋ",
  "ﾌ",
  "ﾍ",
  "ﾎ",
  "ﾏ",
  "ﾐ",
  "ﾑ",
  "ﾒ",
  "ﾓ",
  "ﾔ",
  "ｲ",
  "ﾕ",
  "ｴ",
  "ﾖ",
  "ﾗ",
  "ﾘ",
  "ﾙ",
  "ﾚ",
  "ﾛ",
  "ﾜ",
  "ｦ",
  "ﾝ",
  "ｶﾞ",
  "ｷﾞ",
  "ｸﾞ",
  "ｹﾞ",
  "ｺﾞ",
  "ｻﾞ",
  "ｼﾞ",
  "ｽﾞ",
  "ｾﾞ",
  "ｿﾞ",
  "ﾀﾞ",
  "ﾁﾞ",
  "ﾂﾞ",
  "ﾃﾞ",
  "ﾄﾞ",
  "ﾊﾞ",
  "ﾋﾞ",
  "ﾌﾞ",
  "ﾍﾞ",
  "ﾎﾞ",
  "ﾊﾟ",
  "ﾋﾟ",
  "ﾌﾟ",
  "ﾍﾟ",
  "ﾎﾟ",
  "ｧ",
  "ｨ",
  "ｩ",
  "ｪ",
  "ｫ",
  "ｬ",
  "ｭ",
  "ｮ",
  "ｯ",
  "ﾞ",
  "ﾟ",
  "､",
  "｡",
  "｢",
  "｣",
  "ｰ",
  "･"
];
class u {
  // #region 文字列操作
  /**
   * 文字列比較
   * @param str1    比較する文字列
   * @param str2    比較する文字列
   * @return -1 str1がstr2より順序が先の場合
   * @return 0  str1とstr2が同一の場合
   * @return 1  str1がstr2より順序が後の場合
   */
  static compare(e, t) {
    return e === t ? 0 : e < t ? -1 : 1;
  }
  /**
   * 文字列の先頭から文字セットに含まれていない文字に到達するまで、文字列の先頭からすべての文字を返します
   * @param str       対象の文字列
   * @param charset   文字セット
   * @return 抽出した文字列
   */
  static spanIncluding(e, t) {
    let n = "", r = "";
    for (; e.length !== 0 && u.startsWith(e, t); )
      r = e.slice(0, 1), e = e.replace(r, ""), n = n + r;
    return n;
  }
  /**
   * 文字列の先頭から文字セットにある文字に到達するまで、文字列の先頭からすべての文字を返します
   * @param str       対象の文字列
   * @param charset   文字セット
   * @return 抽出した文字列
   */
  static spanExcluding(e, t) {
    let n = "", r = "";
    for (; e.length !== 0 && !u.startsWith(e, t); )
      r = e.slice(0, 1), e = e.replace(r, ""), n = n + r;
    return n;
  }
  /**
   * 任意の文字セットで始まるかを判定
   * @param str       対象の文字列
   * @param charset 文字セット
   * @return true   文字列が任意の文字セットで始まる
   * @return false  文字列が任意の文字セット以外で始まる
   */
  static startsWith(e, t) {
    for (let n of t)
      if (e.lastIndexOf(n, 0) === 0)
        return !0;
    return !1;
  }
  /**
   * 任意の文字セットから一致する文字を削除する
   * @param str       対象の文字列
   * @param charset   文字セット
   * @return 文字セットが削除された文字列
   */
  static strip(e, t) {
    for (let n of t)
      e = e.replace(new RegExp(n, "g"), "");
    return e;
  }
  // #endregion
  // #region 変換関数
  /**
   * 全角文字→半角文字へ変換
   * @param str  文字列
   * @return 半角文字列
   */
  static convertToHarfWidthChar(e) {
    return e.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248));
  }
  /**
  * 全角かな→全角カナへ変換
  * @param str  文字列
  * @return 全角カナ文字列
  */
  static convertToKatakana(e) {
    return e.replace(/[\u3041-\u3096]/g, (t) => String.fromCharCode(t.charCodeAt(0) + 96));
  }
  /**
   * 全角カナ→半角カナへ変換
   * @param str  文字列
   * @return 半角カナ文字列
   */
  static convertToHarfWidthKatakana(e) {
    let t = "";
    for (let n = 0; n < e.length; n++) {
      let r = e.charAt(n), a = Y.indexOf(r);
      a >= 0 && (r = z[a]), t = t + r;
    }
    return t;
  }
  /**
   * 半角カナ→全角カナへ変換
   * 注意：濁音文字はそのまま2文字で変換されます。「ｶﾞ」→「カ゛」
   * @param str  文字列
   * @return 全角カナ文字列
   */
  static convertToFullWidthKatakana(e) {
    let t = "";
    for (let n = 0; n < e.length; n++) {
      let r = e.charAt(n), a = z.indexOf(r);
      a >= 0 && (r = Y[a]), t = t + r;
    }
    return t;
  }
  /**
   * パスカルケース（単語の先頭が大文字）からキャメルケース（先頭の単語はすべて小文字で以降の単語は先頭が大文字）に変換します。
   * @param pascalCase パスカルケースの文字列
   */
  static pascalCaseToCamelCase(e) {
    return 2 <= e.length ? e.charAt(0).toLowerCase() + e.slice(1) : e.toLowerCase();
  }
  // #endregion
}
var T;
((A) => {
  A.NUMBER_CHAR_SET = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "０", "１", "２", "３", "４", "５", "６", "７", "８", "９"], A.IGNORING_CHAR_SET = ["ﾞ", "ﾟ"];
})(T || (T = {}));
class I {
  // #region public Methods
  /**
   * 与えられた2つの文字列を比較
   * @param str1    比較する文字列
   * @param str2    比較する文字列
   * @param bStrict 文字コード順による厳密な比較をするか
   * @return -1 str1がstr2より順序が先の場合
   * @return 0  str1とstr2が同一の場合
   * @return 1  str1がstr2より順序が後の場合
   */
  static compare(e, t, n = !0) {
    let r = e, a = t;
    for (; r.length !== 0 || a.length !== 0; ) {
      let s = I.nextToken(r), o = I.nextToken(a), i = I.compareToken(s, o);
      if (i != 0)
        return i;
      r = r.substring(s.string.length), a = a.substring(o.string.length);
    }
    return n ? u.compare(e, t) : 0;
  }
  /**
   * 与えられた2つの文字列をそれぞれ区切り文字列で分割し、分割された文字列を比較
   * @param str1      比較する文字列
   * @param str2      比較する文字列
   * @param delimiter 区切り文字
   * @return -1 str1がstr2より順序が先の場合
   * @return 0  str1とstr2が同一の場合
   * @return 1  str1がstr2より順序が後の場合
   */
  static compareDelimiter(e, t, n) {
    let r = [], a = [];
    r = e.split(n), a = t.split(n);
    let s = r.length, o = a.length;
    for (let i = 0; i < r.length; i++) {
      let f = I.compare(r[i], a[i], !1);
      if (f !== 0)
        return f;
    }
    if (s < o)
      return -1;
    if (s > o)
      return 1;
    for (let i = 0; i < s && i < o; i++) {
      let f = u.compare(r[i], a[i]);
      if (f != 0)
        return f;
    }
    return 0;
  }
  // #endregion
  // #region private Methods
  /**
   * 与えられた文字列を正規化
   * 【正規化する内容】
   * 漢字対象外
   * かな文字→全角カナ（濁音文字は清音へ変換）
   * 全角英字（大文字）→半角英字（小文字）
   * 全角数字→半角数字
   * @param str   正規化する文字列
   * @param type  トークン
   * @return 正規化された文字列
   */
  static normalize(e, t) {
    let n = "";
    if (t === 1)
      n = u.convertToHarfWidthChar(e);
    else if (t === 2) {
      let r = e;
      r = u.convertToKatakana(r), r = u.convertToHarfWidthKatakana(r), r = u.strip(r, T.IGNORING_CHAR_SET), r = u.convertToFullWidthKatakana(r), r = u.convertToHarfWidthChar(r), r = r.toLowerCase(), n = r;
    }
    return n;
  }
  /**
   * 与えられた文字列の最初のトークンを取得
   * @param str トークンを取得したい文字列
   * @return トークン
   */
  static nextToken(e) {
    let t = new X();
    return e.length === 0 ? (t.type = 0, t.string = "") : u.startsWith(e, T.NUMBER_CHAR_SET) ? (t.type = 1, t.string = u.spanIncluding(e, T.NUMBER_CHAR_SET), t.strNoramlized = I.normalize(
      t.string,
      1
      /* TOKEN_TYPE_NUMBER */
    )) : (t.type = 2, t.string = u.spanExcluding(e, T.NUMBER_CHAR_SET), t.strNoramlized = I.normalize(
      t.string,
      2
      /* TOKEN_TYPE_STRING */
    )), t;
  }
  /**
   * 与えられた2つのトークンを比較
   * @param token1 比較する文字列
   * @param token2 比較する文字列
   * @return -1 str1がstr2より順序が先の場合
   * @return 0  str1とstr2が同一の場合
   * @return 1  str1がstr2より順序が後の場合
   */
  static compareToken(e, t) {
    if (e.type != t.type)
      return e.type < t.type ? -1 : 1;
    if (e.type === 0)
      return 0;
    if (e.type === 1) {
      let n = Number(e.strNoramlized), r = Number(t.strNoramlized);
      return n < r ? -1 : n > r ? 1 : 0;
    }
    return e.type === 2 ? u.compare(e.strNoramlized, t.strNoramlized) : 0;
  }
  // #endregion
}
class X {
  constructor() {
    d(this, "type", 0);
    // トークンの種類
    d(this, "string", "");
    // トークンの内容
    d(this, "strNoramlized", "");
  }
  // 正規化されたトークンの内容
}
function lt(A) {
  return typeof A == "string" ? 0 < A.length ? [A] : [] : A;
}
function ct(A) {
  return A.toString(2).split("").reverse().map((e, t) => e === "1" ? t : -1).filter((e) => e !== -1);
}
class ft {
  /**
   * 以下のルールに従って100分率を算出します。
   * - 0より大きく1未満の場合は有効桁数で切り上げ
   * - 99より大きく100未満の場合は有効桁数で切り捨て
   * - それ以外は有効桁数で切り捨て
   * @param dividend 被除数
   * @param divisor 序数
   * @param precision 有効桁数
   */
  static toPercentage(e, t, n) {
    if (t === 0)
      throw new Error("Divisor cannot be zero.");
    const r = e * 100 / t, a = Math.pow(10, n ?? 0);
    return 0 < r && r < 1 ? Math.ceil(r * a) / a : 99 < r && r < 100 ? Math.floor(r * a) / a : Math.round(r * a) / a;
  }
}
var j = /* @__PURE__ */ ((A) => (A[A.None = 0] = "None", A[A.Png = 1] = "Png", A[A.Jpeg = 2] = "Jpeg", A[A.Bmp = 4] = "Bmp", A[A.Gif = 8] = "Gif", A[A.Jpg = 16] = "Jpg", A[A.Tiff = 32] = "Tiff", A[A.Tif = 64] = "Tif", A))(j || {});
class _ {
  /**
   * 画像の拡張子Bitから、MIME文字列を作成します
   */
  static GetMIMEType(e) {
    const t = [];
    return e & 1 && t.push("image/png"), e & 18 && t.push("image/jpeg"), e & 4 && t.push("image/bmp"), e & 8 && t.push("image/gif"), e & 96 && t.push("image/tiff"), t.join(",");
  }
  /**
   * 画像の拡張子Bitから、拡張子一覧を作成します
   */
  static GetExtensions(e) {
    const t = [];
    return e & 16 && t.push(".jpg"), e & 2 && t.push(".jpeg"), e & 1 && t.push(".png"), e & 64 && t.push(".tif"), e & 32 && t.push(".tiff"), e & 4 && t.push(".bmp"), e & 8 && t.push(".gif"), t.join(",");
  }
  /**
   * 画像の拡張子Bitから、有効な拡張子かを判断します
   */
  static ValidateExtensions(e, t) {
    var n = e.lastIndexOf(".");
    if (n === -1)
      return !1;
    let r = e.slice(n).toLowerCase();
    return _.GetExtensions(t).split(",").includes(r);
  }
  /**
   * @brief Canvasに描画された画像に透明度（アルファチャンネル）が含まれるかを判定します。
   * @param canvas 判定対象のHTMLCanvasElement
   * @returns 透明度を持つピクセルが1つでもあればtrue、なければfalseを返します。
   */
  static hasAlphaChannel(e) {
    const t = e.getContext("2d");
    if (!t)
      return !1;
    const r = t.getImageData(0, 0, e.width, e.height).data;
    for (let a = 3; a < r.length; a += 4)
      if (r[a] < 255)
        return !0;
    return !1;
  }
  /**
   * 画像ファイルをリサイズします
   */
  static AsyncImageResizing(e, t, n) {
    return new Promise((r, a) => {
      const s = e.type === "image/tiff" || /\.(tif|tiff)$/i.test(e.name), o = new FileReader();
      o.onload = (i) => {
        if (i.target === null || i.target.result === null) {
          a("Error: e.target.result is null");
          return;
        }
        if (s) {
          try {
            const l = i.target.result, E = F.decode(l);
            F.decodeImage(l, E[0]);
            const m = F.toRGBA8(E[0]), { width: B, height: S } = E[0], g = document.createElement("canvas"), x = g.getContext("2d");
            if (!x) return a("Error: Unable to get canvas context");
            const N = document.createElement("canvas"), U = N.getContext("2d");
            if (!U) return a("Error: Unable to get temp canvas context");
            N.width = B, N.height = S;
            const K = U.createImageData(B, S);
            K.data.set(m), U.putImageData(K, 0, 0);
            let w = 1;
            if (t < B && (w = t / B), n < S) {
              const O = n / S;
              O < w && (w = O);
            }
            if (g.width = B * w, g.height = S * w, x.drawImage(N, 0, 0, g.width, g.height), _.hasAlphaChannel(g))
              r(g.toDataURL("image/png"));
            else {
              const O = g.toDataURL("image/png"), H = g.toDataURL("image/jpeg");
              r(O.length <= H.length ? O : H);
            }
          } catch (l) {
            a(l);
          }
          return;
        }
        const f = new Image();
        f.onload = function() {
          var S;
          const l = document.createElement("canvas"), E = l.getContext("2d");
          if (E === null) {
            a("Error: Unable to get canvas context");
            return;
          }
          if (_.IsAnimatedGif((S = i.target) == null ? void 0 : S.result)) {
            a("Error: Animated GIF is not supported");
            return;
          }
          let m = 1;
          if (t < f.width && (m = t / f.width), n < f.height) {
            const g = n / f.height;
            g < m && (m = g);
          }
          if (l.width = f.width * m, l.height = f.height * m, E.drawImage(f, 0, 0, l.width, l.height), _.hasAlphaChannel(l))
            r(l.toDataURL("image/png"));
          else {
            const g = l.toDataURL("image/png"), x = l.toDataURL("image/jpeg");
            r(g.length <= x.length ? g : x);
          }
        }, f.onerror = (l) => a("Error loading image: " + l), f.src = i.target.result;
      }, o.onerror = (i) => {
        a("Error loading file:" + i);
      }, s ? o.readAsArrayBuffer(e) : o.readAsDataURL(e);
    });
  }
  /**
   * @brief GIFがアニメーションかどうかを判定します。
   * @param dataUrl 判定したいGIF画像のDataURL
   * @returns アニメーションGIFであればtrue、静止画GIFであればfalseを返します。
   */
  static IsAnimatedGif(e) {
    if (!e.startsWith("data:image/gif;base64,"))
      return !1;
    try {
      const t = {
        // ブロックタイプ識別子
        BLOCK_TYPE: {
          IMAGE_SEPARATOR: 44,
          // 各画像フレームの開始
          EXTENSION_BLOCK: 33,
          // 拡張ブロック(コメント, アニメーション制御など)
          GIF_FILE_END_MARKER: 59
          // ファイルの終端マーカー
        },
        // 構造上のオフセットとサイズ
        HEADER_SIZE: 6,
        LOGICAL_SCREEN_DESCRIPTOR_SIZE: 7,
        PACKED_FIELDS_INDEX: 10,
        IMAGE_DESCRIPTOR_SIZE: 9,
        // ビットマスク (特定のビットを調べるための道具)
        MASKS: {
          HAS_COLOR_TABLE: 128,
          // 1000 0000 (最上位ビット)
          COLOR_TABLE_SIZE: 7
          // 0000 0111 (下位3ビット)
        },
        BYTES_PER_COLOR: 3,
        // 1色あたりのバイト数 (R, G, B)
        DATA_SUB_BLOCK_END: 0
        // データサブブロックの終端
      }, n = e.split(",")[1], r = atob(n), a = new Uint8Array(r.length);
      for (let l = 0; l < r.length; l++)
        a[l] = r.charCodeAt(l);
      let s = 0, o = 0;
      o += t.HEADER_SIZE + t.LOGICAL_SCREEN_DESCRIPTOR_SIZE;
      const i = a[t.PACKED_FIELDS_INDEX];
      if ((i & t.MASKS.HAS_COLOR_TABLE) > 0) {
        const l = 1 << (i & t.MASKS.COLOR_TABLE_SIZE) + 1;
        o += t.BYTES_PER_COLOR * l;
      }
      for (; o < a.length; ) {
        const l = a[o];
        if (l === t.BLOCK_TYPE.IMAGE_SEPARATOR) {
          if (s++, s > 1)
            return !0;
          o += 1 + t.IMAGE_DESCRIPTOR_SIZE;
          const E = a[o - 1];
          if ((E & t.MASKS.HAS_COLOR_TABLE) > 0) {
            const B = 1 << (E & t.MASKS.COLOR_TABLE_SIZE) + 1;
            o += t.BYTES_PER_COLOR * B;
          }
          o++;
        } else if (l === t.BLOCK_TYPE.EXTENSION_BLOCK)
          o += 2;
        else if (l === t.BLOCK_TYPE.GIF_FILE_END_MARKER)
          return !1;
        for (; o < a.length && a[o] !== t.DATA_SUB_BLOCK_END; ) {
          const E = a[o];
          o += E + 1;
        }
        o++;
      }
      return s > 1;
    } catch {
      return !1;
    }
  }
}
const R = class R {
  /**
   * データURIからファイル名を作成
   * @param   [in]    dataURI : データURI
   * @param   [in]    prefix : プレフィックス
   * @return  ファイル名（GUIDで作成）
   */
  static CreateFileName(e, t = void 0) {
    let n = "";
    return e.startsWith("data:image/png") ? n = "png" : e.startsWith("data:image/jpeg") ? n = "jpg" : n = "", t == null ? `${k()}.${n}` : `${t}_${k()}.${n}`;
  }
  /**
   * データURI⇒FileContentDataURI
   * @param   [in]    dataURI : データURI
   * @return  FileContentDataURI（※ファイル名はGUIDで作成）
   */
  static DataURIToFileContent(e) {
    return {
      dataURI: e,
      fileName: R.CreateFileName(e),
      fileSize: R.DataURItoFileSize(e)
    };
  }
  /*
  * HTML内のデータURIをファイル名に変換
  * @param   [in]    srcHtml : HTMLテキスト(<img>のsrcはデータURI)
  * @return  [in]    callbackSetFileList : ファイル情報をセットするコールバック関数
  * @return  fileList: 変換したファイル情報
  */
  static DataURIsToFileNames_InHTML(e, t) {
    let n = e;
    if (n.indexOf("img", 0) !== void 0) {
      const r = /<img[^>]*?src="([^"]*?)"[^>]*?>/gi;
      let a, s = n;
      for (; (a = r.exec(n)) !== null; ) {
        const o = a[1], i = R.DataURIToFileContent(o);
        t(i.dataURI, i.fileName, i.fileSize), s = s.replace(i.dataURI, i.fileName);
      }
      n = s;
    }
    return n;
  }
  /*
  * HTML内のファイル名をデータURIに変換
  * @param   [in]    srcHtml : HTMLテキスト(<img>のsrcはファイル名)
  * @param   [in]    callbackGetFileInfo : ファイル情報を取得するコールバック関数（dataURI: データURI, fileName: ファイル名）
  * @return  srcHtml内のファイル名をデータURIに置き換えた文字列
  */
  static FileNamesToDataURIs_InHTML(e, t, n) {
    let r = e;
    for (let a = 0; a < t; a++) {
      const s = n(a);
      s.fileName !== void 0 && s.fileName !== null && s.dataURI !== void 0 && s.dataURI !== null && (r = r.replace(s.fileName, s.dataURI));
    }
    return r;
  }
  /*
  * HTML内の<img>タグのsrcを列挙します
  * @param   [in]    srcHtml : HTMLテキスト
  * @return  srcHtml内のsrc一覧
  */
  static EnumImgSrc_inHtml(e) {
    const t = new Array();
    if (e.indexOf("img", 0) !== void 0) {
      const n = /<img[^>]*?src="([^"]*?)"[^>]*?>/gi;
      let r;
      for (; (r = n.exec(e)) !== null; ) {
        const a = r[1];
        t.push(a);
      }
    }
    return t;
  }
  /*
  * データURIの文字列から、バイナリ時のサイズを計算します
  * @param   [in]    dataURI : データURI
  * @return  バイナリ時のファイルサイズ
  */
  static DataURItoFileSize(e) {
    const t = e.replace(/^data:.*;base64,/, ""), n = t.length;
    return Math.ceil(n * 3 / 4) - (t.endsWith("==") ? 2 : t.endsWith("=") ? 1 : 0);
  }
  /*
   * データURIが取得失敗の画像かどうか
   * @param   [in]    dataURI : データURI
   */
  static IsPicFailedImage(e) {
    return e.toUpperCase() === R.PIC_FAILED_IMAGE.toUpperCase();
  }
};
/**
 * 取得失敗の画像
 */
d(R, "PIC_FAILED_IMAGE", "data:image/jpeg;base64,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");
let Z = R;
export {
  At as BootstrapUtil,
  P as ConvStorageUtil,
  st as CookieUtil,
  Z as DataURIUtil,
  W as HttpRequestUtil,
  j as ImageTypeBit,
  _ as ImageUtil,
  V as LoadingUtil,
  ft as MathUtil,
  it as ModalUtil,
  I as NaturalCompare,
  Q as ObjectUtil,
  y as RoundType,
  u as StringHelper,
  ot as UUIDUtil,
  ct as toBitPositions,
  lt as toStringArray
};
